var ModalHandler = {
    handleClick: function (elem) {
        var modalkaID = elem.attr('data-modalka');
        var attrId = elem.attr('data-id');
        var attrSubId = elem.attr('data-sub-id');

        if (elem.hasClass('to_cart')) {
            this.handleToCartClick(modalkaID, attrId, attrSubId, elem);
        } else {
            this.handleRegularClick(modalkaID, attrId, attrSubId);
        }
    },

    handleToCartClick: function (modalkaID, attrId, attrSubId, elem) {
        var color = $('#color_select');
        var sizes = $('#sizes_select');

        if (color.val() !== '' && sizes.val() !== '') {
            var good_id = elem.attr('data-id');
            var count = elem.attr('data-count');
            var size = elem.attr('size-id');
            var colorId = elem.attr('color-id');
            request_card
            $(".good_order_info").empty();

            $.ajax({
                type: "POST",
                url: "service/reload-good-order",
                data: {
                    "good_id": good_id,
                    "count": count,
                    "size_id": size,
                    "color_id": colorId,
                },
                success: function (data) {
                    if (!$('#' + modalkaID).hasClass('active')) {
                        $('#' + modalkaID).addClass('active');
                        $('body').addClass('overflow');
                    }
                    reloadTopCart();
                    $(".good_order_info").html(data);
                },
            });
        } else {
            this.handleSelectError(color, sizes);
        }
    },

    handleSelectError: function (color, sizes) {
        if (color.val() === '') {
            color.parents('.product__select').addClass('product__select--error');
        } else {
            color.parents('.product__select').removeClass('product__select--error');
        }

        if (sizes.val() === '') {
            sizes.parents('.product__select').addClass('product__select--error');
        } else {
            sizes.parents('.product__select').removeClass('product__select--error');
        }
    },

    handleRegularClick: function (modalkaID, attrId, attrSubId) {
        if (!$('#' + modalkaID).hasClass('active')) {
            $('#' + modalkaID).addClass('active');
            $('body').addClass('overflow');
        }

        this.setInputValue(modalkaID, 'id', attrId);
        this.setInputValue(modalkaID, 'sub_id', attrSubId);
    },

    setInputValue: function (modalkaID, inputName, value) {
        if (value !== '' && typeof value !== 'undefined' && value !== false) {
            var input = $('#' + modalkaID).find('[name="' + inputName + '"]');
            if (input.length !== 0) {
                input.val(value);
            }
        }
    },

    handleClose: function (elem) {
        if ($('.modalka').hasClass('active')) {
            $('.modalka').removeClass('active');
            $('body').removeClass('overflow');
        }
    }
};

$(document).ready(function () {
    $(document).on('click', '.modalka__open', function () {
        ModalHandler.handleClick($(this));
    });

    $(document).on('click', '.modalka__overlay, .modalka__close, .modalka__close-btn', function () {
        ModalHandler.handleClose($(this));
    });
});
